import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TempUser, TemporalUserVerificationRequest } from '../models/dto/temp-user';
import { LikedProducts } from '../models/dto/liked-products';
import { LikedQualities } from '../models/dto/liked-qualities';
import { Plato } from '../models/dto/carta-menu';
import { ListLikedQualities } from '../models/dto/list-liked-qualities';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  tempUserData: any = TempUser;
  get getTempUserData(){
    return this.tempUserData;
  }

  private readonly urlApi = environment.url_api;
  private readonly urlApiV2 = environment.url_api_v2;
  constructor(private http: HttpClient) { }

  

  editTemporalUser(data: any):Observable<boolean> {
    let urlRegistro = this.urlApi + 'User/Edit';
    return this.http.post<boolean>(urlRegistro, data);
  }

  loginTemporalUser(data: any):Observable<boolean> {
    let urlRegistro = this.urlApi + 'Login/User';
    return this.http.post<boolean>(urlRegistro, data);
  }


  setLikedQualities(data: LikedQualities):Observable<boolean> {
    let urlRegistro = this.urlApi + 'Qualities';
    return this.http.post<boolean>(urlRegistro, data);
  }

  getLikedQualities(sndevice:string):Observable<Array<ListLikedQualities>>{
    let urlRegistro = this.urlApi + 'Qualities/' + sndevice;
    return this.http.get<Array<ListLikedQualities>>(urlRegistro);
  }

  //V2
  setTemporalUser(data: any): Observable<string> {
    let urlRegistro = this.urlApiV2 + "api/v2/usuarios/temporal";
    
    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<string>(urlRegistro, data, { headers });
  }

  updateVerificationCode(obj: TemporalUserVerificationRequest): Observable<string> {

    let urlRegistro = this.urlApiV2 + "api/v2/usuarios/temporal/verificacion";
    
    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<string>(urlRegistro, obj, { headers });
  }

  recoveryPwd(obj:any): Observable<string> {
    let urlRegistro = this.urlApiV2 + "api/v2/usuarios/temporal/recovery";
    
    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<string>(urlRegistro, obj, { headers });
  }

  getLikedProductsv2(sndevice:string, menuId: number):Observable<Array<number>>{
    let urlRegistro = this.urlApiV2 + 'api/v2/usuarios/productos/favoritos/' + sndevice + "/" + menuId;
    return this.http.get<Array<number>>(urlRegistro);

  }

  setLikedProductsv2(data: LikedProducts) {
    let urlRegistro = this.urlApiV2 + 'api/v2/usuarios/productos/favoritos';
    return this.http.post<boolean>(urlRegistro, data);
  }
  //V2
}
